// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const LocationsPage = lazy(() => import('./pages/LocationsPage'));
const BinsPage = lazy(() => import('./pages/BinsPage'));
const StockTransfersPage = lazy(() => import('./pages/StockTransfersPage'));
const BatchSerialPage = lazy(() => import('./pages/BatchSerialPage'));
const CycleCountsPage = lazy(() => import('./pages/CycleCountsPage'));
const ReceivingPage = lazy(() => import('./pages/ReceivingPage'));
const FifoLifoPage = lazy(() => import('./pages/FifoLifoPage'));

export const WarehouseRoutes: RouteObject = {
  path: 'warehouse',
  element: <ModuleGuard moduleId="operations.warehouse" />,
  children: [
    { path: 'locations', element: <LocationsPage />, handle: { crumb: 'Locations' } },
    { path: 'bins', element: <BinsPage />, handle: { crumb: 'Bins' } },
    { path: 'stock-transfers', element: <StockTransfersPage />, handle: { crumb: 'Stock Transfers' } },
    { path: 'batch-serial', element: <BatchSerialPage />, handle: { crumb: 'Batch Serial' } },
    { path: 'cycle-counts', element: <CycleCountsPage />, handle: { crumb: 'Cycle Counts' } },
    { path: 'receiving', element: <ReceivingPage />, handle: { crumb: 'Receiving' } },
    { path: 'fifo-lifo', element: <FifoLifoPage />, handle: { crumb: 'FIFO / LIFO Costing' } },
  ],
};
